import { useEffect, useCallback } from 'react';

export default function useClickOutside(
	handler,
	parentSelector,
	condition = true,
) {
	const handleClickOutside = useCallback(
		(event) => {
			if (condition) {
				const isChild = event.target?.closest(parentSelector);
				if (!isChild) {
					handler();
				}
			}
		},
		[handler, parentSelector, condition],
	);

	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [handleClickOutside]);
}
